var nurseslounge_lounge_activity = {
    init:function($params){
        $(window).nurseslounge_lounge_wall($params);
        $params = $.extend({},$params, {tab:'init'});
        nurseslounge_lounge_overview.information_lounge_get('init', $params, function($data){
            nurseslounge_lounge_activity.information_administrator_edit($params, $data);
            if(
                $data.data.lounge.lounge_type_id == 1 || //employer
                $data.data.lounge.lounge_type_id == 2 //school
            ){
                nurseslounge_lounge_activity.information_rating($params, $data);
            }
            try{
                google.maps.event.addListener(window, "load", nurseslounge_lounge_activity.information_location_map($data));
            }catch (e) {

            }
        });
        nurseslounge_myDashboard_activity.lounge_follow_request(function($chtml){
            nurseslounge_lounge_activity.lounge_follow_container($chtml);
        });
        nurseslounge_lounge_activity.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_lounge_activity.task_list_container(function($container){
            $params = $.extend({}, $params, {only:'owners'});
            nurseslounge_myDashboard_myProfile.task_list($container, $params);
        });
        nurseslounge_lounge_activity.information_meet_our_recruiters(function($config){
            nurseslounge_lounge_overview.information_meet_our_recruiters_engine($config);
        });
        nurseslounge_lounge_activity.report_container(function($container){
            nurseslounge_lounge_overview.report($container, $params);
        });
        nurseslounge_lounge_activity.lounge_ads_location(function($config){
            nurseslounge_lounge_overview.lounge_ads_engine($config);
        });
    },
    //Administrator
    information_administrator_edit:function($params, $data){
        var $modal = $("#nurseslounge-lounge-information-edit-modal");
        var $isEmployer = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 1 : false;
        var $isSchool = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 2 : false;
        var $isSpecialty = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 8 : false;
        var $thoughtLeaders = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 9 : false;
        var $credential = $data && $data.data && $data.data.user_credential ? $data.data.user_credential : [];
        $isEmployer = !$isEmployer ? $params.typeName == 'employers' : $isEmployer;
        $isSchool = !$isSchool ? $params.typeName == 'schools' : $isSchool;
        $isSpecialty = !$isSpecialty ? $params.typeName == 'specialties' : $isSpecialty;
        $thoughtLeaders = !$thoughtLeaders ? $params.typeName == 'thoughtLeaders' : $thoughtLeaders;
        $credential = $credential.map(function($x){return parseInt($x);});
        var $createNewLoungeAccess = $.inArray(5, $credential) != -1 ? true : false;
        var $editNewLoungeAccess = $.inArray(6, $credential) != -1   ? true : false;
        var $deleteNewLoungeAccess = $.inArray(15, $credential) != -1  ? true : false;
        var $helpVideos = $.inArray(37, $credential) != -1  ? true : false;
        var $allowTabs = {
            'information': $.inArray(7, $credential) != -1 ? true : false,
            'otherNames': $.inArray(62, $credential) != -1 && !$thoughtLeaders ? true : false,
            'specialties': $.inArray(80, $credential) != -1 && $isSpecialty || $.inArray(80, $credential) != -1 && $thoughtLeaders ? true : false,
            'location':    $.inArray(8, $credential) != -1 && !$thoughtLeaders ? true : false,
            'multimedia':  $.inArray(9, $credential) != -1 ? true : false,
            'virtualTour':  $.inArray(83, $credential) != -1 && !$thoughtLeaders ? true : false,
            'recruiters':  $.inArray(10, $credential) != -1 && !$thoughtLeaders ? true : false,
            'owners':  $.inArray(11, $credential) != -1 ? true : false,
            'jobs':  $.inArray(12, $credential) != -1 && $isEmployer || $.inArray(12, $credential) != -1 && $isSchool ? true : false,
            'import':  $.inArray(13, $credential) != -1 && $isEmployer || $.inArray(13, $credential) != -1 && $isSchool ? true : false,
            'api':  $.inArray(13, $credential) != -1 && $isEmployer || $.inArray(13, $credential) != -1 && $isSchool ? true : false,
            'statistics':  $.inArray(14, $credential) != -1 ? true : false,
            'degrees':  $.inArray(17, $credential) != -1 && $isSchool ? true : false,
            'invite':  $.inArray(24, $credential) != -1 ? true : false,
            'inviteStatistics':  $.inArray(28, $credential) != -1 ? true : false,
            'inviteTemplates':  $.inArray(66, $credential) != -1 ? true : false,
            'createLogo':  $.inArray(67, $credential) != -1 ? true : false,
            'buyAds':  $.inArray(71, $credential) != -1 && $isSchool ? true : false,
            'sponsorDegrees':  $.inArray(75, $credential) != -1 && $isSchool ? true : false,
            'spotlightJobs':  $.inArray(77, $credential) != -1 && !$isSchool && !$thoughtLeaders ? true : false,
        };
        var $allowTabsFiltered = $allowTabs;
        $allowTabs = {};
        $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
        var $information = $("#nurseslounge-lounge-activity");
        var $informationRight = $information.find('.nurseslounge-lounge-activity-right:first .administrator:first');
        var $options = $informationRight.find('.option');
        $options.each(function(){
            var $that = $(this);
            var $action = $that.data('action');
            if(
                $createNewLoungeAccess && $action == 'create' ||
                $editNewLoungeAccess && $action == 'edit' ||
                $deleteNewLoungeAccess && $action == 'delete' ||
                $helpVideos && $action == 'help-videos' ||
                $helpVideos && $action == 'create-pin-it' ||
                $helpVideos && $action == 'create-event' ||
                $helpVideos && $action == 'send-invitation' ||
                $helpVideos && $action == 'examples-posts'
            ) {
                $that.unbind().click(function () {
                    var $tab = null;
                    $.each($allowTabs, function($i, $v){
                        if($v){
                            $tab = $i;
                            return false;
                        }
                    });
                    if(
                        $tab && $action == 'create' ||
                        $tab && $action == 'edit'
                    ){
                        nurseslounge_lounge_overview.information_administrator_select_tab($action, $tab, $allowTabs, $params, function () {
                            $modal.scrollTop(0);
                            $modal.modal('show');
                        });
                    }else
                    if($tab && $action == 'help-videos'){
                        window.open('https://www.home.nurseslounge.com/help-center', '_blank', '');
                    }else
                    if($tab && $action == 'create-pin-it'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=NedHuxskMV8');
                    }else
                    if($tab && $action == 'create-event'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=Dd4XKeHIAo0');
                    }else
                    if($tab && $action == 'send-invitation'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_video('https://www.youtube.com/watch?v=FbQw8gA_KmU');
                    }else
                    if($tab && $action == 'examples-posts'){
                        nurseslounge_lounge_overview.information_administrator_tab_open_images();
                    }else
                    if($action == 'delete'){
                        if(confirm('Are you sure you want to delete this lounge?')){
                            $params = $.extend({},$params, {action:$action,tab:$action});
                            nurseslounge_lounge_overview.information_administrator_tab_request($params, function($data){
                                if($data.status == 'success'){
                                    router.navigate('/lounges');
                                }
                            });
                        }
                    }
                });
            }
        });
        if($isEmployer){
            $modal.find('.nav-pills .nav-link[data-target="#otherNames"]').html("Facility Names");
        }else{
            $modal.find('.nav-pills .nav-link[data-target="#otherNames"]').html("Other Names");
        }
    },
    //Rating And Reviews
    information_rating:function($params, $data){
        var $typeId = $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id : 0;
        var $nursesloungeLoungeInformation = $("#nurseslounge-lounge-activity");
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $loungeInformationRight = $nursesloungeLoungeInformation.find('.nurseslounge-lounge-activity-right:first');
        var $ratingFirst = $loungeInformationRight.find('.rating-stars:first');
        var $ratingCount = $loungeInformationRight.find('.rating-count:first');
        var $addReviewFirst = $loungeInformationRight.find('.add-review:first');
        var $deleteReviewFirst = $loungeInformationRight.find('.delete-review:first');
        $ratingFirst.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_lounge_activity.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $ratingCount.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_lounge_activity.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $addReviewFirst.unbind().click(function(){
            nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                libs.refreshBoxFrom('.review-box', $params, function(){
                    nurseslounge_lounge_activity.init($params);
                    $reviewModal.modal('hide');
                });
            });
        });
        $deleteReviewFirst.unbind().click(function(){
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_lounge_overview.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.review-box', $params, function(){
                        nurseslounge_lounge_activity.init($params);
                        $reviewModal.modal('hide');
                    });
                });
            }
        });
    },
    //Map Location
    information_location_map:function($data){
        var $location = $data && $data.data && $data.data.lounge && $data.data.lounge.location ? $data.data.lounge.location : null;
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
            var $iconUrl =  './../../bimg/NursesLounge/active.png';
            var $map = new google.maps.Map(document.getElementById('nurseslounge-lounge-activity-right-map'), {
                center:$position,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoom: 15
            });
            $map.setTilt(0);
            var $marker = new google.maps.Marker({
                position:$position,
                map: $map,
                animation: google.maps.Animation.DROP,
                icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
            });
        }
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-lounge-activity .nurseslounge-lounge-activity-right .banners")
        });
    },
    lounge_ads_location:function(cback){
        cback({
            'ads':$("#nurseslounge-lounge-activity .nurseslounge-lounge-activity-right .lounge-ads")
        });
    },
    //Follow Lounges
    lounge_follow_container:function($chtml){
        libs.checkImageLoad($($chtml).find('img'), function(){
            $("#nurseslounge-lounge-activity .nurseslounge-lounge-activity-right .follow-lounges").html($chtml);
        });
    },
    //Task List Container
    task_list_container:function(cback){
        var $container = $("#nurseslounge-lounge-activity .nurseslounge-lounge-activity-right");
        cback($container);
    },
    //Pin IT
    pin_it:function($params, cback){
        nurseslounge_lounge_activity.pin_it_request($params, function($data){
            router.navigate('/lounge/'+$data.data.lounge_key+'/activity');
            setTimeout(function(){
                var $activity = $(".nav-underline a[data-id='activity']");
                $(".nav-underline a").removeClass('active');
                $params = $.extend({}, $params, {key:$data.data.lounge_key,post:$data.data.post});
                nurseslounge_lounge.submenu_open($activity[0], $activity.data('url'),  $activity.data('id')+'_sub', $params);
                nurseslounge_lounge.menu_selector();
                if(cback != undefined){
                    cback($data);
                }
            }, 5000);
        });
    },
    pin_it_request:function($params, cback){
        $.ajax({
            url:"/lounge/activity/pinIt/get",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Meet our recruiters
    information_meet_our_recruiters:function(cback){
        cback({
            'container':$("#nurseslounge-lounge-activity .nurseslounge-lounge-activity-right .meet-our-recruiters")
        });
    },
    //Report
    report_container:function(cback){
        var $container = $("#nurseslounge-lounge-activity .nurseslounge-lounge-activity-right .report");
        cback($container);
    },
};
